import React, {useCallback} from "react";
import {useParams} from "react-router";
import {DiaEditorCreateRedirectFunction,  useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import {
    CreateRoleMutation,
    GetRoleQueryResult,
    Role, UpdateRoleMutation, UpdateRoleMutationResult,
    useCreateRoleMutation,
    useGetRoleQuery,
    useUpdateRoleMutation
} from "../../generated/graphql";
import {RoleForm} from "./Form";
import {useUserContext} from "../../contexts/user-context";
import { MutationResult } from "@apollo/client";


const relationships = {
    permissions:'connect'
};


function makeBlankValues():Role  {
    return {
        id: 'new',
        name:'',
        permissions:[]
    };
}

export function RoleEditor() {
    const params = useParams();
    const isNew = (params.id=='new');
    const user = useUserContext();
    const query = useGetRoleQuery({variables:{id:params.id},skip:isNew});
    const [saveMutation,saveResult] = useUpdateRoleMutation();
    const [createMutation,createResult] = useCreateRoleMutation();
    const readOnly = !(user.hasPermission('roles.edit'));
    console.log('readONLY',readOnly);
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[]);
    const getValue = useCallback((result:GetRoleQueryResult)=>{
        return result?.data?.role;
    },[]);
    const getSaveValue = useCallback((result:UpdateRoleMutationResult)=>{
        return result?.data?.updateRole;
    },[]);
    const getCreateRedirect = useCallback<DiaEditorCreateRedirectFunction<MutationResult<CreateRoleMutation>>>(({data,baseUrl})=>{
        return baseUrl+(data.data?.createRole?.id);
    },[]);
    /*const getCreateValue = useCallback((result:CreateRoleMutationResult)=>{
        return result?.data?.createRole;
    },[]);*/
    const data = useDiaEditor<Role,GetRoleQueryResult,CreateRoleMutation,UpdateRoleMutation>({
        save,
        saveResult,
        create,
        createResult,
        query: query,
        relationships: relationships,
        baseUrl: '/contacts/',
        blankValues: makeBlankValues,
        label: 'Roles',
        permission: 'roles',
        getValue: getValue,
        getSaveValue: getSaveValue,
        getCreateRedirect: getCreateRedirect
    });
    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    console.log('data0 is',data);
    if(data.form.status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    console.log('data is',data);
    return <RoleForm diaForm={data.form} readOnly={readOnly}/>;
}